import { COMPANY, SITE_ALTERNATE_NAMES, SITE_NAME, SITE_URL, SOCIAL_PROFILES } from "./siteSeo";

export function buildWebSiteJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    name: SITE_NAME,
    alternateName: [...SITE_ALTERNATE_NAMES],
    url: SITE_URL,
    inLanguage: "tr-TR",
    publisher: { "@id": `${SITE_URL}/#organization` },
  };
}

export function buildAutoRepairJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    "@id": `${SITE_URL}/#organization`,
    name: COMPANY.name,
    legalName: COMPANY.legalName,
    alternateName: [...SITE_ALTERNATE_NAMES],
    url: SITE_URL,
    image: `${SITE_URL}/images/card.png`,
    logo: `${SITE_URL}/images/card.png`,
    telephone: [COMPANY.phone, COMPANY.altPhone],
    email: COMPANY.email,
    sameAs: [SOCIAL_PROFILES.instagram, SOCIAL_PROFILES.whatsapp, SOCIAL_PROFILES.maps],
    address: {
      "@type": "PostalAddress",
      streetAddress: COMPANY.addressStreet,
      addressLocality: COMPANY.addressLocality,
      postalCode: COMPANY.postalCode,
      addressRegion: COMPANY.addressRegion,
      addressCountry: COMPANY.addressCountry,
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: COMPANY.geo.latitude,
      longitude: COMPANY.geo.longitude,
    },
    areaServed: {
      "@type": "City",
      name: "İstanbul",
    },
    priceRange: "₺₺",
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        opens: "08:00",
        closes: "18:30",
      },
    ],
  };
}

export function buildBreadcrumbJsonLd(items: Array<{ name: string; path: string }>) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path.startsWith("/") ? item.path : `/${item.path}`}`,
    })),
  };
}

export function buildServiceJsonLd(input: {
  title: string;
  description: string;
  path: string;
  image?: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: input.title,
    description: input.description,
    provider: { "@id": `${SITE_URL}/#organization` },
    areaServed: "İstanbul",
    url: `${SITE_URL}${input.path}`,
    image: input.image ? `${SITE_URL}${input.image.split("?")[0]}` : `${SITE_URL}/images/card.png`,
  };
}

export function buildBlogPostingJsonLd(input: {
  title: string;
  description: string;
  path: string;
  image?: string;
  datePublished: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: input.title,
    description: input.description,
    image: input.image ? `${SITE_URL}${input.image.split("?")[0]}` : `${SITE_URL}/images/card.png`,
    datePublished: input.datePublished,
    author: {
      "@type": "Organization",
      name: SITE_NAME,
      url: SITE_URL,
    },
    publisher: { "@id": `${SITE_URL}/#organization` },
    mainEntityOfPage: `${SITE_URL}${input.path}`,
  };
}
